var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 80,
    viewBox: "0 0 54 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2794 0.0915513C8.80461 1.02537 0.667016 9.82998 0 25.705H15.6082C15.7416 20.2354 18.9433 16.0999 24.5462 15.4329C30.1491 14.8993 35.4852 16.2333 37.0861 19.9686C38.8203 24.1041 34.9516 28.9066 33.084 30.9077C29.6155 34.643 24.0126 37.4444 21.0777 41.4465C18.2762 45.4486 17.7426 50.6514 17.4758 57.0547H31.2163C31.3497 52.9192 31.6165 49.0505 33.4842 46.5159C36.5525 42.3804 41.0882 40.5127 44.8235 37.1776C48.4254 34.1094 52.294 30.3741 52.8277 24.5043C55.0955 7.29532 40.9548 -0.975674 24.2794 0.0915513Z",
    fill: "#131316",
    fillOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6795 79.9999C29.4685 79.9999 33.3507 76.1774 33.3507 71.4621C33.3507 66.7468 29.4685 62.9243 24.6795 62.9243C19.8905 62.9243 16.0083 66.7468 16.0083 71.4621C16.0083 76.1774 19.8905 79.9999 24.6795 79.9999Z",
    fill: "#131316",
    fillOpacity: 0.05
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.ac78e0f4921dbec4cdd8586294a5bb5d.svg";
export { ForwardRef as ReactComponent };